<template>
  <div class="Notice">
      <Header/>
      <div class="content">
          <div class="current-loc">
            <span>{{ $t('satellite.CurrentPosition') }}：</span>
            <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">{{ $t('satellite.Home') }}</el-breadcrumb-item>
            <el-breadcrumb-item>{{ $t('home.PlatformAnnouncement') }}</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <p class="title">{{ $t('home.PlatformAnnouncement') }}</p>
          <hr>
          <div class="data-table">
              <el-table
                :empty-text="$t('Intelligent.NoData')"
                :header-cell-style="header_cell_style_bd"
                :cell-style="cell_style_bd"
                :style="cell_style_bd"
                :data="tableData"
                ref="noticeTable"
                border>
                <el-table-column
                prop="noticeContent"
                :label="$t('home.content')"
                align="center">
                </el-table-column>
                <el-table-column
                prop="noticeTime"
                :label="$t('home.time')"
                width="240"
                align="center">
                </el-table-column>
            </el-table>
          </div>
          <div class="pagenation">
                <el-pagination
                background
                @current-change="currentChange"
                layout="prev, pager, next"
                :total="total"
                :page-size="20">
                </el-pagination>
          </div>
      </div>
      <Footer/>
  </div>
</template>

<script>
import Header from "@/components/Header"
import Footer from "@/components/Footer"
import {
    getNoticeList,
} from "@/api/notice/index"
import { mapGetters} from "vuex";
export default {
    name:'Notice',
    components: {
        Header,
        Footer
    },
    data(){
        return{
            noticeContent:'',
            currentNotice:'',
            newDialog:false,
            tableData:[],
            total:0,
            page:{
                limit:20,
                page:1
            },
            isEdit:false,
        }
    },

    watch:{
        newDialog(val){
            if(!val){
                this.noticeContent = ''
            }
        }
    },
    computed:{
        ...mapGetters(['header_cell_style_bd','cell_style_bd']),
    },
    created(){
        this.getList()
    },
    methods:{
        /**
         * @description: 页面跳转
         * @brief: 
         * @Author: chenwei
         * @Date: 2022-07-12 10:56:18
         * @param {*} val
         * @return {*}
         */
        currentChange(val){
            this.page.page = val
            this.getList()
        },
        async getList(){
            let that = this
            let res = await getNoticeList(that.page)
            that.tableData = res.data.list
            that.total = parseInt(res.data.totalCount)
            console.log(res);
        }
    }
}
</script>

<style lang="scss" scoped>
hr{
    @include hr_white_to_black();
}
.current-loc{
    height: 21px;
    display: flex;
    align-items: center;
    margin-top: 60px;
    /deep/ span{
        font-size: 15px;
        @include co_white_to_black();
    }
    /deep/ a{
        @include co_white_to_black();
    }
    /deep/ .el-breadcrumb__item:last-child{
        span{
            color: rgba(38,125,255,1);
        }
    }
}
.Notice{
    width: 100%;
    @include table_page_bg();
    .content{
        min-height: 600px;
        margin: 0 auto;
        width: 1551px;
        .label{
            margin: 60px 0 20px 0;
        }
        .title{
            font-size: 28px;
            color: rgba(39,121,202,1);
            margin: 20px 0;
        }
        .query{
            display: flex;
            align-items: center;
            font-size: 15px;
            margin: 20px 0;
            .search{
                width: 240px;
                margin: 0 12px;
            }
            .search-btn{}
        }
        .data-table{
            margin: 20px 0;
            .Notice-status1{
                width: 8px;
                height: 8px;
                border-radius: 50px;
                background: green;
                margin-right: 8px
            }
            .Notice-status2{
                @extend .Notice-status1;
                background: rgba(24,144,255,1);
            }
            .Notice-status3{
                @extend .Notice-status1;
                background: rgba(215,218,225,1);
            }
            .Notice-status{
            }
        }
        .pagenation{
            display: flex;
            justify-content: flex-end;
            padding-right: 0;
            margin: 20px 0;
        }
    }
    ::v-deep .btn-next{
        margin-right: 0;
    }
    ::v-deep .el-pagination{
        padding-right: 0;
    }
}
.down-dialog-main{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .down-dialog-site{
        margin-bottom: 12px;
        span{
            display: inline-block;
            width: 100px;
            text-align: right;
        }
        
    }
}
</style>
